module.exports = __webpack_public_path__ + "img/social.dfff327e.jpg";